module.exports = __webpack_public_path__ + "static/media/BannerMt.8ec34a08.svg";